<template>
  <div class="row mt-2 px-3">
    <HeaderBreadcrumbs :items="[
      { label: 'Sales - Gramedia Digital' },
    ]" title="All Sales - Gramedia Digital" />

    <div class="bg-white w-full rounded-xl p-4">
      <div class="flex flex-row justify-start items-end mb-4">
        <div class="w-full flex flex-row justify-between items-end">
          <div class="flex flex-col pr-0">
            <label class="text-gray-600 font-semibold mb-2">Invoice</label>
            <input type="text" v-model="query_search"
              class="w-full border border-gray-300 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Type Invoice No." onfocus="this.placeholder = 'type invoice number...'"
              @input="actionGetReportInvoice()" />
          </div>
          <div class="flex flex-col pr-0">
            <label class="text-gray-600 font-semibold mb-2">Period Date</label>
            <PeriodPicker @range-selected="onRangeSelected" @month-selected="onMonthSelected" @clear="onClear" />

          </div>
          <div class="flex flex-col w-64 pr-0">
            <label class="text-gray-600 font-semibold mb-2">Offer Type</label>
            <TypeDropdown class="w-32" v-model="offerType" :options="offerTypeOptions"
              :defaultText="'Select Offer Type'" />
          </div>
          <div class="flex flex-col pr-3 w-1/3">
            <label class="text-gray-600 font-semibold mb-2">Publisher (Optional)</label>
            <multiselect v-model="publisher" label="name" track-by="name" :disabled="userData.role_id === 5"
              placeholder="Type Publisher" open-direction="bottom" :options="publisherSearchOptions"
              :loading="isPublisherSearch" :multiple="true" :searchable="true" :close-on-select="false"
              @search-change="publisherFind">
            </multiselect>
          </div>
          <button class=" bg-blue-700 text-white  px-4  rounded-lg py-2.5 w-auto " @click="onFilter">
            Filter
          </button>
        </div>
      </div>
      <div v-if="items?.length">
        <Table :headers="headers" 
        :data="items"
        :row-key="['vendor_name', 'number_invoice', 'disbursement_period', 'offer_type']" :current-page="currentPage"
        :isLoading="isLoading" :per-page="50">

        <template #disbursement_period="{ value }">
          {{ formatPeriod(value) }}
        </template>
        <template #header-disbursement-period="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                  </svg>
                </span>
            </button>
          </div>
        </template>
        <template #offer_type="{ value }">
          <span class="px-2 py-1 rounded-lg text-xs font-medium capitalize" :class="offerTypeColor(value)">
            {{ value }}
          </span>
        </template>
        <template #actions={row}>
          <div v-if="userData.role_id === 1 ||
      userData.role_id === 14 ||
      userData.role_id === 5  // && isPeriodAllowed(row.disbursement_period)

      ">
            <b-button :id="`invoice-download-${row.number_invoice}`"
              :variant="row.is_active ? 'outline-primary' : 'outline-danger'" @click="downloadInvoice({
      offer_type: row.offer_type,
      vendor_id: row.vendor_id,
      period: row.disbursement_period,
      number_invoice: row.number_invoice
    })" v-if="row.alloweddownload" :disabled="isButtonDisabled(row)">
              <template v-if="row.is_active && !isLoadingBtn(row) && !isDownloaded(row)">
                <i class="fa fa-download"></i> Download
              </template>

              <template v-else-if="!row.is_active">
                <i class="fa fa-ban"></i> Unavailable
              </template>
              <!-- Loading spinner -->
              <template v-else-if="isLoadingBtn(row)">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="d-inline-block ml-2" tabindex="0" data-toggle="tooltip" :title="tooltipText">
                  Loading ..
                </span>
              </template>

              <!-- Success check -->
              <template v-else-if="isDownloaded(row)">
                <i class="fa fa-check"></i>
                <span class="d-inline-block ml-2" tabindex="0" data-toggle="tooltip" :title="tooltipText">
                  Processed
                </span>
              </template>
            </b-button>
          </div>
          <div v-if="!row.alloweddownload">
            <i class="fa fa-warning"> </i>
            Vendor Id Issue
          </div>
        </template>
      </Table>
      </div>
      <div v-else-if="!query_search">
        <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 65vh;">
                    <svg class="w-16 h-16 text-gray-800 dark:text-white" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path
                        d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                    </svg>

                    <h4 class="text-base text-gray-600 mb-0">Select Filter to Display</h4>
                    <p class="text-sm text-gray-500">Your data will be displayed once the filter has been selected.</p>
                  </div>
      </div>
      <div v-if="query_search && items.length === 0">
        <div class="flex-col items-center justify-center flex-nowrap flex" style="height: 65vh;">
                <svg width="35" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z"
                    fill="#4B5563" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z"
                    fill="#4B5563" />
                  <path
                    d="M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z"
                    fill="#4B5563" />
                </svg>
                <h4 class="text-base text-gray-600 mb-0">No results found</h4>
                <p class="text-sm text-gray-500">Change your keyword or filter</p>
              </div>
      </div>
      <div v-if="!isLoading && items?.length"
        class="flex bg-white justify-between pl-3 pr-3 pt-4 mb-0 border-t border-gray-100 mt-1">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
            @change="onClickPage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import { ReportInvoiceSinglePath } from '../../router/report';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import PeriodPicker from '@/components/form/PeriodDate.vue'
import TypeDropdown from '@/components/form/StatusFilterComponent.vue'
import Table from '@/components/form/table.vue'
import constant from '../../store/constant';
export default {
  name: 'manage-report-invoice',
  components: {
    HeaderBreadcrumbs,
    PeriodPicker,
    TypeDropdown,
    Table
  },
  data() {
    return {
      dates: null,
      ReportInvoiceSinglePath,
      tooltipText: '',
      userData: JSON.parse(localStorage.getItem('session_auth')),
      indexRow: -1,
      currentPage: 1,
      activeInvoiceId: null,
      buttonLoading: false,
      buttonDownloaded: false,
      perPage: 50,
      query_search: '',
      isLoadingSearchByInvoiceNumber: false,
      isLoadingSearchByDisbursementPeriod: false,
      searchMode: '1',
      sortOrder: 'desc',
      showOnDataTable:false,
      searchModeOptions: [
        { value: '1', text: 'Search By Number Invoice' },
        { value: '2', text: 'Search By Disbursement Period' },
      ],
      headers: [
        { label: 'No', key: 'no' },
        { label: 'Vendor', key: 'vendor_name' },
        { label: 'invoice number', key: 'number_invoice' },
        { label: 'Date', key: 'disbursement_period', sortable: true, slotHeader: 'header-disbursement-period' },
      
        { label: 'offer type', key: 'offer_type' },

      ],
      range: {
        start: moment()
          .startOf('month')
          .subtract(1, 'M')
          .format('YYYY-MM-DD'),
        end: moment()
          .subtract(1, 'M')
          .endOf('month')
          .format('YYYY-MM-DD'),
      },
      masks: {
        input: 'YYYY-MM-DD',
      },
      offerType: 0,
      offerTypeOptions: [
        { value: 0, text: 'All Offer' },
        { value: constant.OFFER_TYPE.SINGLE, text: 'Single' },
        { value: constant.OFFER_TYPE.BUNDLE, text: 'Bundle' },
        { value: constant.OFFER_TYPE.SUBSCRIPTIONS, text: 'Subscriptions' },
        { value: constant.OFFER_TYPE.BUFFET, text: 'Buffet' },
      ],
      debounce: null,
      alertCheckRevenue: null,
      isLoadingCheckRevenue: false,
      publisher: [],
      publisherSearchOptions: [],
      isPublisherSearch: false,
      fields: [
        { key: 'No', label: 'No' },
        {
          key: 'vendor_name',
          label: 'Vendor',
        },
        {
          key: 'number_invoice',
          label: 'Number Invoice',
        },
        {
          key: 'disbursement_period',
          label: 'Period',
        },
        {
          key: 'offer_type',
          label: 'Offer Type',
        },
        {
          key: 'disbursement',
          label: 'Estimated Revenue'
        },
        { key: 'action_download', label: 'Download' },
        // { key: "action_button", label: "Action" },
      ],
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.report.isLoading,
      items: (state) => state.report.items,
      isError: (state) => state.report.isError,
      totalRows: (state) => state.report.totalRows,
      errorMessage: (state) => state.report.errorMessage,
      successMessage: (state) => state.report.successMessage,
      selfVendorId: (state) => state.report.selfVendorId,
      isDownloadLoading: (state) => state.report.isDownloadLoading,
    }),
  },
  watch: {
    errorMessage: function () {
      if (!this.errorMessage) return;
      this.messageAlert('error', this.errorMessage, 5000);
    },
    successMessage: function () {
      if (!this.successMessage) return;
      this.messageAlert('success', this.successMessage);
    },
    currentPage: function () {
      this.actionGetReportInvoice();
    },
mounted() {
  this.actionGetReportInvoice()
},
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Invoice | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  created() {
    this.publisherFind();
    this.fields = this.fields.filter(field => field.key !== 'disbursement');
  },
  methods: {
    ...mapActions('report', [
      'fetchReportInvoice',
      'searchReportInvoice',
      'downloadReportInvoiceIntoEmailPublisher',
      'getReportInvoiceTotalRevenue',
    ]),
    ...mapActions('vendors', ['searchVendors']),
onFilter() {
  this.showOnDataTable = true
  let payload = {
          page: this.currentPage = 1,
          limit: this.perPage,
        };
        if (this.dates) {
          payload.startRange = moment(this.dates[0]).endOf('month').format('YYYY-MM-DD');
          payload.endRange = this.dates[1] ? moment(this.dates[1]).endOf('month').format('YYYY-MM-DD') : moment(this.dates[0]).endOf('month').format('YYYY-MM-DD');
        }
        if (this.query_search) {
          payload.q = this.query_search.trim()
      } 
        if (this.offerType) payload.offer = this.offerType;
        if (this.publisher?.length) {
          payload.publisher = this.publisher
            ? this.publisher.map((val) => val?.id)
            : '';
        }
        this.fetchReportInvoice(payload);
        this.setQuery(payload);

},
    actionGetReportInvoice() {
      this.buttonDownloaded = []
      if (this.query_search) {
        let payload = {
          q: this.query_search.trim(),
          page: this.currentPage = 1,
          limit: this.perPage,
        };
        this.fetchReportInvoice(payload);
        this.setQuery(payload);
      } 
      else {
        let payload = {
          page: this.currentPage,
          limit: this.perPage,
        };
        if (this.dates) {
          payload.startRange = moment(this.dates[0]).endOf('month').format('YYYY-MM-DD');
          payload.endRange = this.dates[1] ? moment(this.dates[1]).endOf('month').format('YYYY-MM-DD') : moment(this.dates[0]).endOf('month').format('YYYY-MM-DD');
        }
        if (this.offerType) payload.offer = this.offerType;
        if (this.publisher?.length) {
          payload.publisher = this.publisher
            ? this.publisher.map((val) => val?.id)
            : '';
        }
        this.fetchReportInvoice(payload);
        this.setQuery(payload);
        return payload;
      }
    },
    sortBy(sortByPeriode) {
    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';

    const payload = this.actionGetReportInvoice();
    payload.order_by = sortByPeriode;
    payload.sort = this.sortOrder;
    this.fetchReportInvoice(payload);
  },
    setQuery(q = {}) {
      this.$router.push({ query: q }).catch(() => { });
    },
    isLoadingBtn(row) {
      return this.buttonLoading && this.activeInvoiceId === row.number_invoice;
    },
    isDownloaded(row) {
      return this.buttonDownloaded && this.activeInvoiceId === row.number_invoice;
    },
    // isPeriodAllowed(period) {
    //   const [year, month] = period.split("-").map(Number);
    //   if (this.userData.role_id !== 5) {
    //     return true;
    //   }
    //   if (year > 2025 || (year === 2025 && month > 4)) {
    //     return false;
    //   }
    //   return true;
    // },
    isButtonDisabled(row) {
      return this.isLoadingBtn(row) || this.isDownloaded(row) || !row.is_active  // || !this.isPeriodAllowed(row.disbursement_period);
    },

    offerTypeColor(Type) {
      switch (Type) {
        case 'single':
          return 'bg-blue-100 text-blue-700';
        case 'bundle':
          return 'bg-green-100 text-green-700';
        case 'subscription':
          return 'bg-yellow-200 text-yellow-800';
        case 'buffet':
          return 'bg-purple-100 text-purple-700';
        default:
          return 'bg-gray-100 text-gray-600';
      }
    },
    setQuerySearch(query) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.query_search = query;
      }, 1000);
    },
    setSearchMode(mode) {
      this.searchMode = mode;
    },
    formatDate(tgl) {
      if (tgl) {
        return moment(tgl).format('DD MMM YY hh:mm');
      }
      return '-';
    },
    formatPeriod(tgl) {
      if (tgl) {
        return moment(tgl).format('D MMMM YYYY');
      }
      return '-';
    },

    asyncFindByInvoiceNumber() {
      this.isLoadingSearchByInvoiceNumber = true;
      clearTimeout(this.debounce);
      this.publisher = [];
      this.offerType = 0;
      this.range.start = moment().format('DD MMM YY');
      this.range.end = moment().format('DD MMM YY');
      this.debounce = setTimeout(() => {
        const query = this.query_search;
        const modeQuery = 1;
        if (!query || !modeQuery) {
          this.actionGetReportInvoice();
          this.isLoadingSearchByInvoiceNumber = false;
          return;
        }
        this.searchReportInvoice({
          q: query,
          page: this.currentPage = 1,
          limit: this.perPage,
          mode: modeQuery,
        })
          .then((response) => {
            this.items = response.data.data.rows;
            this.isLoadingSearchByInvoiceNumber = false;
          })
          .catch(() => {
            this.isLoadingSearchByInvoiceNumber = false;
          });
      }, 1000);
    },
    asyncFindByDisbursementPeriod() {
      this.isLoadingSearchByDisbursementPeriod = true;
      this.query_search = null;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        const modeQuery = 2;
        if (!modeQuery) {
          this.actionGetReportInvoice();
          this.isLoadingSearchByDisbursementPeriod = false;
          return;
        }
        const payload = {
          page: this.currentPage = 1,
          limit: this.perPage,
          mode: modeQuery,
          startRange: this.range.start
            ? new Date(this.range.start).toISOString()
            : null,
          endRange: this.range.end
            ? new Date(this.range.end).toISOString()
            : null,
          offer: this.offerType,
          publisher: this.publisher.map((item) => item.id),
        };
        this.searchReportInvoice(payload)
          .then((response) => {
            this.items = response.data.data.rows;
            this.isLoadingSearchByDisbursementPeriod = false;
          })
          .catch(() => {
            this.isLoadingSearchByDisbursementPeriod = false;
          });
      }, 1000);
    },
    asyncClearFind() {
      this.query_search = '';
      this.searchMode = '1';
      this.isLoadingSearchByInvoiceNumber = false;
      this.isLoadingSearchByDisbursementPeriod = false;
      this.range = {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
      };
      this.offerType = 0;
      this.publisher = [];
      this.publisherSearchOptions = [];
      this.actionGetReportInvoice();
    },
    showModal(numberInvoice) {
      this.alertCheckRevenue = null;
      this.isLoadingCheckRevenue = false;
      this.$refs[`${numberInvoice}`].show();
    },
    async downloadInvoice(row) {
      this.buttonLoading = true;
      this.buttonDownloaded = false;
      this.tooltipText = this.successMessage || 'Invoice berhasil diproses, silakan cek email Anda dalam 5 menit ke depan.';
      setTimeout(() => {
        this.buttonLoading = false;
        this.buttonDownloaded = true;
        this.downloadReportInvoiceIntoEmailPublisher(row);
      }, 8000);
      this.activeInvoiceId = row.number_invoice;

    },
    messageAlert(icon, title, timer = 3000) {
      this.$swal({
        toast: 'true',
        position: 'top-end',
        icon,
        title,
        showConfirmButton: false,
        timer,
        timerProgressBar: true,
      });
    },
    setOfferType(type) {
      this.offerType = type;
    },
    async publisherFind(query) {
      if (this.userData.role_id === 5) {
        try {
          const response = await this.searchVendors({ email: this.userData.email });
          this.publisherSearchOptions = response.data.data.rows;
          this.publisher = this.publisherSearchOptions
        } catch (error) {
          console.error('Error fetching publisher data:', error);
        }
      }

      if (!query) return;
      this.isPublisherSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          q: query,
          limit: 10,
        };
        this.searchVendors(payload)
          .then((response) => {
            this.publisherSearchOptions = response.data.data.rows;
            this.isPublisherSearch = false;
          })
          .catch(() => {
            this.isPublisherSearch = false;
          });
      }, 600);
    },
    onRangeSelected({ startRange, endRange }) {
      this.dates = [startRange, endRange];
    },
    onMonthSelected({ selected }) {
      this.dates = [selected];
    },
    onClear() {
      this.dates = null
      this.actionGetReportInvoice()
    },
    onClickPage(page) {
      this.currentPage = page;
    },
    clearInvoiceNumber() {
      this.query_search = null;
    },
    formatCurrency(value, currency) {
      if (value) {
        let formatter = null;
        if (currency == 'USD') {
          formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
          });
        } else if (currency == 'SGD') {
          formatter = new Intl.NumberFormat('en-SG', {
            style: 'currency',
            currency: currency,
          });
        } else {
          formatter = new Intl.NumberFormat('en-ID', {
            style: 'currency',
            currency: currency,
          });
        }

        return formatter.format(value);
      }

      return 'In callculated';
    }
  },
};
</script>
<style scoped>
.badge-purple {
  background-color: #ff06dc;
}

.badge-yellow {
  background-color: #ffec2e;
  color: black;
}
</style>
